// Modules
import cn from 'classnames';

// Types
import type { TPaginationButtonProps } from './Pagination.type';

// Styles
import styles from './styles.module.scss';

// Constants
import { PAGINATION_BUTTON_DEFAULT_PROPS } from './Pagination.constant';

export const PaginationButton = (props: TPaginationButtonProps) => {
	const {
		active,
		className,
		disabled,
		label = PAGINATION_BUTTON_DEFAULT_PROPS.label,
		...restProps
	} = props;

	const paginationButtonCN = cn(styles.legion_pagination_button, className, {
		[styles.active]: active,
		[styles.disabled]: disabled,
	});

	return (
		<button className={paginationButtonCN} disabled={disabled} {...restProps}>
			{label}
		</button>
	);
}

export default PaginationButton;
